<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="introduction">
<h1>Introduction</h1>
<p>Organisations and businesses may vary, but there are overarching business management principles, which can be applied to them.</p>
<p>Most businesses have:</p>
<ul>
<li><p>staff;</p></li>
<li><p>customers;</p></li>
<li><p>key stakeholders;</p></li>
<li><p>to deliver a product or service;</p></li>
<li><p>to meet targets/objectives;</p></li>
<li><p>a budget; and</p></li>
<li><p>to maximise profits/productivity.</p></li>
</ul>
<p>Therefore, all managers need certain skills, including being financially savvy and able to set direction, monitor achievement and manage staff.</p>
<p>This book:</p>
<ul>
<li><p>seeks to equip managers, by providing them with common sense business management principles, to guide their decision-making and actions;</p></li>
<li><p>is written in a simplistic, easy-to-read format;</p></li>
<li><p>provides practical tips for busy new managers;</p></li>
<li><p>includes relatable examples, to help demonstrate the principles; and</p></li>
<li><p>could be used by mentors, to generate conversation and develop up-and-coming managers.</p></li>
</ul>
<p>Applying these principles may help managers to avoid:</p>
<ul>
<li><p>injuring their staff;</p></li>
<li><p>damaging their own, or the organisation’s, reputation;</p></li>
<li><p>wasting time; and</p></li>
<li><p>creating unnecessary distractions from desired outputs.</p></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?49ac1fe3